import styled from 'styled-components';
import minus from './minus.svg';
import plus from './plus.svg';

type Props = {
  open: boolean;
  setOpen: (v: boolean) => void;
};
export const IconBtnPlusMinus = ({ open, setOpen }: Props) => {
  return <Btn onClick={() => setOpen(!open)}>{open ? <img src={minus} /> : <img src={plus} />}</Btn>;
};

const Btn = styled.button``;
